// Where the club's KyckConnect pages live in the portal. One definition, read by the nav, the routes and the redirects.
export const PORTAL_DASHBOARD_PATH = '/portal/kyckconnect/dashboard';
export const PORTAL_REPORTING_PATH = '/portal/kyckconnect/reporting';
export const PORTAL_LEADS_PATH = '/portal/kyckconnect/leads';
export const PORTAL_SETUP_PATH = '/portal/kyckconnect/setup';
/** The old "Who we call" address: it redirects to the Speed to Lead step of Setup. */
export const PORTAL_WHO_WE_CALL_OLD_PATH = '/portal/speed-to-lead';
export const PORTAL_SETUP_SPEED_TO_LEAD_PATH = `${PORTAL_SETUP_PATH}?step=speed-to-lead`;
export const PORTAL_LEAD_CONVERSATIONS_OLD_PATH = '/portal/lead-conversations';

/**
 * Where the old "Lead conversations" address (`/portal/lead-conversations?c=<conversation>`) lands. A link carrying a conversation
 * opens that conversation's lead once it has resolved; an unresolved one (not found, or another club's: a 404) and a link with no
 * conversation land on the list. ⚠️ It never builds a lead id itself: only the server, having checked the viewer's scope, may name one.
 */
export function leadsRedirectTarget(conversation: string | null, resolvedLeadId: string | null): string {
  if (!conversation || !resolvedLeadId) return PORTAL_LEADS_PATH;
  return `${PORTAL_LEADS_PATH}?lead=${encodeURIComponent(resolvedLeadId)}`;
}
